exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3XWVg{font-size:26px;color:#36404a;display:inline-block;margin:0 40px 0 0;font-weight:700}._34nJT{font-size:16px;padding-right:30px;text-decoration:none;display:inline-block}._34nJT a{display:block;color:#818a92}._32gF7{opacity:0;margin:3px auto 0;width:14px;height:3px;background:#fb4a3e;border-radius:100px;-webkit-transition:opacity .3s;-o-transition:opacity .3s;transition:opacity .3s}._2JYxG ._32gF7,._34nJT:hover ._32gF7{opacity:1}", ""]);

// exports
exports.locals = {
	"root": "b1bEr",
	"title": "_3XWVg",
	"navItem": "_34nJT",
	"hoverIcon": "_32gF7",
	"cur": "_2JYxG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/p_tag/Nav/index.css
// module id = 1258
// module chunks = 2